export type ToastAction = (
  _: unknown,
  params: {
    type: 'error' | 'warning';
    message: string;
    id?: string;
  },
) => void;

/**
 * A no-op toast action to allow pluggable toasting in machines.
 * This action should be overridden when used in a machine to provide
 * the desired toast implementation.
 */
export const toastAction: ToastAction = () => {
  // eslint-disable-next-line no-console
  console.warn('Toast action not implemented in this machine.');
};
